import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PointOfSalesComponent from './point-of-sales.component';

let PointOfSalesModule = angular
  .module('PointOfSales', [
    uiRouter
  ])
  .component('pointOfSales', PointOfSalesComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('pointOfSales', {
      url: '/point-of-sales',
      data: {
        authRequired: true,
        permsRequired: ['view-pos', 'register-pos']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'pointOfSales'
        },
      },
      resolve: {
        posObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-pos') ? ContentService.getPOSList() : {};
        }
      }
    })
  })
  .name;

export default PointOfSalesModule;



// WEBPACK FOOTER //
// ./src/app/pages/point-of-sales/point-of-sales.module.js